export default "__VITE_ASSET__DieMODVa__"